import styled from 'styled-components';

export const AdminStatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 24px;
  }

  @media (max-width: 480px) {
    gap: 12px;
    margin-bottom: 20px;
  }
`;

export const AdminStatsCard = styled.div<{ $color?: string; $loading?: boolean }>`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #dee2e6;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0) scale(0.98);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: ${props => props.$color || '#667eea'};
  }

  @media (max-width: 768px) {
    padding: 20px;
  }

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

export const AdminStatsCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const AdminStatsCardTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #6c757d;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const AdminStatsCardIcon = styled.span`
  font-size: 24px;
  opacity: 0.8;
`;

export const AdminStatsCardValue = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: #212529;
  margin-bottom: 8px;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

export const AdminStatsCardChange = styled.div<{ $trend: 'up' | 'down' | 'neutral' }>`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 600;
  color: ${props => {
    switch (props.$trend) {
      case 'up': return '#28a745';
      case 'down': return '#dc3545';
      default: return '#6c757d';
    }
  }};
  margin-bottom: 8px;
`;

export const AdminStatsCardTrend = styled.span<{ $trend: 'up' | 'down' | 'neutral' }>`
  font-size: 12px;
`;

export const AdminStatsCardDescription = styled.p`
  font-size: 12px;
  color: #6c757d;
  margin: 0;
  line-height: 1.4;
`;

// Note: Responsive design handled via CSS media queries in global styles
